import * as t from '../types';

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function checkTimeReducer(state = initialState, action) {

    const {type, payload} = action;
    switch (type) {
        case t.GET_CHECK_TIME_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_CHECK_TIME_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload
            };
        case t.GET_CHECK_TIME_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
